"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var initializer_system_1 = require("./initializer-system");
exports.Interface = initializer_system_1.Interface;
exports.INIT_PRIORITY = initializer_system_1.INIT_PRIORITY;
exports.sortInitializers = initializer_system_1.sortInitializers;
//# sourceMappingURL=index.js.map